import { LocalStorageService } from '@mistergreen/shared/angular-injectables/local-storage/local-storage.service'
import { distinctUntilChanged, filter } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { ReplaySubject } from 'rxjs'
import { getQueryStringValue } from '../utilities/getQueryStringValue'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

const localStorageReferralCodeKey = 'referralCode'

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class ReferralService {
    referralCode$: ReplaySubject<string> = new ReplaySubject()

    constructor(private localeStorageService: LocalStorageService) {}

    bootstrap() {
        this.localeStorageService
            .getItemObservable(localStorageReferralCodeKey)
            .pipe(
                untilDestroyed(this),
                filter(referralCode => !!referralCode),
                distinctUntilChanged()
            )
            .subscribe(referralCode => {
                this.referralCode$.next(referralCode)
            })

        const referralCode = getQueryStringValue('referral') || getQueryStringValue('referralCode')
        if (referralCode) {
            this.setReferralCode(referralCode)
        }
    }

    setReferralCode(referralCode: string) {
        this.localeStorageService.setItem(localStorageReferralCodeKey, referralCode)
    }
}
